import React, { Component } from 'react';
import BlemishReportModal from './components/BlemishReportModal';


class BlemishReport extends Component {
    render() {
        const { closeModal } = this.props;
        return (
            <div style={{ minHeight: 200, position: 'relative' }}>
                <BlemishReportModal closeModal={closeModal} />
            </div>
        );
    }
}

export default BlemishReport;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_blemish_report/index.js